import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export const constantRouterMap = [
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true,
    meta: { requireAuth: false }
  },
  {
    path: "/404",
    component: () => import("@/views/404"),
    hidden: true,
    meta: { requireAuth: false }
  },
  { path: "", redirect: "/login" }
];

export default new Router({
  //mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
});



// WEBPACK FOOTER //
// ./src/router/index.js